export const RadnoVrijemeGpsEvdResourceBS: RadnoVrijemeGpsEvdInterface = {
  title: "Evidencija radnog vremena sa GPS lokacijom",
  description:
    "Molimo odaberite period u kojem se nalaze evidencije radnog vremena sa GPS lokacijom.",
  addButton: "Dodaj",
  gpsPermissionMessage:
    "Molimo dozvolite pristup GPS lokaciji kako biste mogli evidentirati radno vrijeme. GPS lokacija je obavezna za praćenje radnog vremena.",
  gpsError: "Greška pri dohvaćanju GPS lokacije. Molimo provjerite dozvole i pokušajte ponovo.",
  gpsNotAvailable: "GPS lokacija nije dostupna. Molimo omogućite pristup GPS lokaciji.",
  inputFields: {
    startDate: {
      label: "Početni datum",
    },
    endDate: {
      label: "Krajnji datum",
    },
    actionType: {
      error: "Molimo odaberite tip akcije.",
      label: "Tip akcije",
      name: "actionType",
      placeholder: "Odaberite tip akcije",
    },
  },
  errors: {
    errorLoading:
      "Došlo je do greške tokom učitavanja evidencije radnog vremena sa GPS lokacijom. Molimo kontaktirajte administratora.",
    errorCreating:
      "Došlo je do greške tokom kreiranja evidencije radnog vremena sa GPS lokacijom. Molimo kontaktirajte administratora.",
    errorDeleting:
      "Došlo je do greške tokom brisanja evidencije radnog vremena sa GPS lokacijom. Molimo kontaktirajte administratora.",
    errorMissingFields:
      "Molimo odaberite tip akcije i dozvolite pristup GPS lokaciji.",
  },
  actionTypes: {
    placeholder: "Odaberite tip akcije",
    startWork: "Početak rada",
    takeBreak: "Početak pauze",
    endBreak: "Kraj pauze",
    endWorkDay: "Kraj radnog dana",
  },
  successModal: {
    title: "Uspješno dodano u bazu",
    body: "Unos radnog vremena sa GPS lokacijom je uspješno sačuvan.",
    buttonOk: "U redu",
  },
  timestampLabel: "Vrijeme:",
  locationLabel: "Lokacija:",
  noLocation: "Lokacija nije dostupna",
};

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface RadnoVrijemeGpsEvdInterface {
  successModal: SuccessModal;
  title: string;
  description: string;
  addButton: string;
  gpsPermissionMessage: string;
  gpsError: string;
  gpsNotAvailable: string;
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    actionType: InputFieldInterface;
  };
  errors: {
    errorLoading: string;
    errorCreating: string;
    errorDeleting: string;
    errorMissingFields: string;
  };
  actionTypes: {
    placeholder: string;
    startWork: string;
    takeBreak: string;
    endBreak: string;
    endWorkDay: string;
  };
  timestampLabel: string;
  locationLabel: string;
  noLocation: string;
}

